import React from "react";

const InterestIncome = () => {
  return <div>InterestIncome</div>;
};

export default InterestIncome;
